import GuardianHoliday from './GuardianHoliday';

export default GuardianHoliday;
